var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.677,
    height: 24.677,
    viewBox: "0 0 24.677 24.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(-38.615 -344.661)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(38.615 344.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(-1268.42 2219.793)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M1322.492-1868.754a.515.515,0,0,1,.374.581c-.007.111,0,.224,0,.35h.573a1.841,1.841,0,0,1,1.438.646,1.724,1.724,0,0,1,.452,1.144c.009,1.125.006,2.25,0,3.375a.46.46,0,0,1-.464.468.465.465,0,0,1-.464-.492q0-1.612,0-3.224a.916.916,0,0,0-.526-.886.934.934,0,0,0-.344-.092c-.216-.014-.433,0-.667,0,0,.16.006.318,0,.475a.462.462,0,0,1-.71.379.454.454,0,0,1-.218-.4c0-.147,0-.294,0-.449h-2.119c0,.139,0,.277,0,.415a.469.469,0,0,1-.461.507.47.47,0,0,1-.469-.511c0-.135,0-.27,0-.413h-2.1c0,.142,0,.28,0,.419a.469.469,0,0,1-.464.5.468.468,0,0,1-.467-.5c0-.139,0-.278,0-.44a5.918,5.918,0,0,0-.795.044.907.907,0,0,0-.718.911c0,.209,0,.419,0,.628q0,3.276,0,6.552a.909.909,0,0,0,.525.9,1.178,1.178,0,0,0,.482.1c1.257.008,2.514.005,3.771,0a.507.507,0,0,1,.4.147.444.444,0,0,1,.1.486.451.451,0,0,1-.385.3.673.673,0,0,1-.093,0c-1.284,0-2.568,0-3.852,0a1.854,1.854,0,0,1-1.774-1.261c-.044-.127-.068-.26-.1-.39v-7.683a.375.375,0,0,0,.022-.063,1.837,1.837,0,0,1,.869-1.312,1.938,1.938,0,0,1,1.133-.278c.138,0,.276,0,.421,0,0-.127.006-.24,0-.351a.514.514,0,0,1,.374-.58h.186a.515.515,0,0,1,.374.58c-.008.114,0,.229,0,.343h2.1c0-.12.006-.232,0-.343a.515.515,0,0,1,.374-.58h.186a.515.515,0,0,1,.374.58c-.008.114,0,.229,0,.343h2.119c0-.12.006-.232,0-.343a.514.514,0,0,1,.374-.58Z",
    fill: "#e85dce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M1578.442-1542.978a1.256,1.256,0,0,1-.918-.351q-.728-.7-1.45-1.414a.454.454,0,0,1-.136-.487.448.448,0,0,1,.353-.319.467.467,0,0,1,.443.148l.708.691q.35.341.7.683a.278.278,0,0,0,.483-.046l2.2-3.073a.476.476,0,0,1,.556-.231.461.461,0,0,1,.269.667.868.868,0,0,1-.056.088q-1.127,1.575-2.255,3.149A1.163,1.163,0,0,1,1578.442-1542.978Z",
    transform: "translate(-256.38 -313.857)",
    fill: "#e85dce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M1418.707-1679.088a.467.467,0,0,1,.465.468.467.467,0,0,1-.47.462.467.467,0,0,1-.459-.462A.467.467,0,0,1,1418.707-1679.088Z",
    transform: "translate(-102.385 -185.242)",
    fill: "#e85dce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M1506-1678.628a.467.467,0,0,1-.465.468.467.467,0,0,1-.465-.467.467.467,0,0,1,.459-.462A.467.467,0,0,1,1506-1678.628Z",
    transform: "translate(-187.19 -185.24)",
    fill: "#e85dce"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M1592.363-1679.089a.467.467,0,0,1,.469.464.467.467,0,0,1-.467.466.467.467,0,0,1-.463-.458A.467.467,0,0,1,1592.363-1679.089Z",
    transform: "translate(-271.994 -185.241)",
    fill: "#e85dce"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M1679.66-1678.619a.467.467,0,0,1-.472.46.468.468,0,0,1-.457-.475.468.468,0,0,1,.467-.454A.467.467,0,0,1,1679.66-1678.619Z",
    transform: "translate(-356.797 -185.242)",
    fill: "#e85dce"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M1419.17-1591.792a.467.467,0,0,1-.469.464.467.467,0,0,1-.461-.472.467.467,0,0,1,.463-.458A.467.467,0,0,1,1419.17-1591.792Z",
    transform: "translate(-102.384 -270.046)",
    fill: "#e85dce"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M1506-1591.8a.467.467,0,0,1-.464.468.467.467,0,0,1-.465-.467.467.467,0,0,1,.458-.462A.467.467,0,0,1,1506-1591.8Z",
    transform: "translate(-187.19 -270.044)",
    fill: "#e85dce"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M1592.374-1592.259a.467.467,0,0,1,.46.473.467.467,0,0,1-.476.457.467.467,0,0,1-.454-.467A.467.467,0,0,1,1592.374-1592.259Z",
    transform: "translate(-271.995 -270.045)",
    fill: "#e85dce"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M1679.2-1591.328a.467.467,0,0,1-.47-.462.467.467,0,0,1,.465-.467.468.468,0,0,1,.465.456A.468.468,0,0,1,1679.2-1591.328Z",
    transform: "translate(-356.8 -270.046)",
    fill: "#e85dce"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M1419.173-1504.97a.467.467,0,0,1-.463.47.467.467,0,0,1-.467-.466.468.468,0,0,1,.457-.464A.467.467,0,0,1,1419.173-1504.97Z",
    transform: "translate(-102.386 -354.849)",
    fill: "#e85dce"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M1506-1504.961a.467.467,0,0,1-.469.464.467.467,0,0,1-.461-.472.467.467,0,0,1,.463-.458A.467.467,0,0,1,1506-1504.961Z",
    transform: "translate(-187.188 -354.852)",
    fill: "#e85dce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceIcon);
export default __webpack_public_path__ + "static/media/AttendanceIcon.49e3e072bddc4b018a8d1afa9389512a.svg";
export { ForwardRef as ReactComponent };